/**
 * Normaliza string de busca pra casar com a coluna search_index do banco.
 *
 * Banco (pack 0034): search_index = unaccent(lower(...))
 * Aqui (client): faz o mesmo via Unicode NFD + strip de combining marks + lower.
 *
 * Garante que digitar 'João' ou 'joao' ou 'JOÃO' procure o mesmo termo.
 *
 * Manter em sincronia com aratek-admin/lib/search.ts (duplicado por design — 2 repos).
 */
export function normalizeForSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // remove combining diacritical marks (acentos)
    .trim()
    .toLowerCase()
}
